import { render } from "./MyTickets.vue?vue&type=template&id=450aed9f&scoped=true"
import script from "./MyTickets.vue?vue&type=script&lang=js"
export * from "./MyTickets.vue?vue&type=script&lang=js"

import "./MyTickets.vue?vue&type=style&index=0&id=450aed9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450aed9f"]])

export default __exports__